export default {
  dataAtualFormatada(date) {
    let data = new Date(date);
    let dia = data.getDate().toString();
    let diaF = dia.length == 1 ? "0" + dia : dia;
    let mes = (data.getMonth() + 1).toString();  
    let mesF = mes.length == 1 ? "0" + mes : mes;
    let anoF = data.getFullYear();

    if (isNaN(anoF)) {
      return null;
    }

    return anoF + "-" + mesF + "-" + diaF;
  },

  dataAtualFormatadaRelatorio(date) {
    let data = new Date(date);
    let dia = data.getDate().toString();
    let diaF = dia.length == 1 ? "0" + dia : dia;
    let mes = (data.getMonth() + 1).toString();  
    let mesF = mes.length == 1 ? "0" + mes : mes;
    let anoF = data.getFullYear();
    return diaF + "-" + mesF + "-" + anoF;
  },

  dataBrSemMascara(date) {
    let data = new Date(date);
    let dia = data.getDate().toString();
    let diaF = dia.length == 1 ? "0" + dia : dia;
    let mes = (data.getMonth() + 1).toString();  
    let mesF = mes.length == 1 ? "0" + mes : mes;
    let anoF = data.getFullYear();
    return diaF + mesF + anoF;
  },

  replace(data) {
    return data.replace(/[^a-zA-Z0-9]/g, "");
  },

  removeNonNumeric(value) {
    if (!value) return "";
    return value.replace(/[^0-9]/g, "");
  },

  formatAtualDate() {
    return new Date().toLocaleString('sv').slice(0, 16);
  },

  isoDateTime(value) {
    if (!value) return null;
    return value.replace("T", " ");
  },

  formatCpf(cpf) {
    if (typeof cpf === "string" && cpf.trim()) {
      const cleanCpf = cpf.replace(/\D/g, "");
      if (cleanCpf.length === 11) {
        return cleanCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
    }
    return "CPF não informado";
  },

  formatHoraDataBr(date) {
    if (!date) return "";

    const data = new Date(date); 
    const hora = data.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    }); 
    const dataBr = data.toLocaleDateString("pt-BR");

    return `${hora} de ${dataBr}`;
  },

  formatErrorMessage(error) {
    let erro = "";
      typeof error.details == "string"
        ? (erro = error.details)
        : (erro = Object.entries(error.details)
            .map(([key, value]) => `${key}: ${value}`)
            .join(""));

    return erro;
  },

  dateTimeLocal(value) {
    if (!value) return null;
      return value.replace(" ", "T").slice(0, 16);
  }
};
